import PromiseCache from './promise-cache';

export default function( umbrella ) {
    const fetch = umbrella.fetch;
    const cache = new PromiseCache();
    const brandingURL = `https://${ window.location.hostname }/api/v1/branding`;

    async function getStyles( options = {} ) {
        const body = JSON.stringify( options );

        return await cache( `getStyles:${ body }`, async () => {
            const res = await fetch(
                `${ brandingURL }/styles`,
                {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body
                }
            );

            const data = await res.json();

            if ( res.ok ) {
                return data;
            } else {
                throw data;
            }
        } )();
    }

    umbrella.getStyles = getStyles;
 }
